import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);
    const { pathname } = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleNavClick = (targetPath: string, sectionId?: string) => (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (pathname !== targetPath) {
            setIsMenuOpen(false);
            return;
        }

        e.preventDefault();
        setIsMenuOpen(false);

        if (targetPath === '/') {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }

        if (!sectionId) return;
        const el = document.getElementById(sectionId);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.scrollY;
            
            const shouldBeVisible = 
                prevScrollPos > currentScrollPos ||
                currentScrollPos < 50;
            
            setVisible(shouldBeVisible);
            setPrevScrollPos(currentScrollPos);
        };

        window.addEventListener('scroll', handleScroll);
        
        return () => window.removeEventListener('scroll', handleScroll);
    }, [prevScrollPos]);

    return (
        <nav 
            className={`brutalist-nav fixed w-full z-50 transition-transform duration-300 ease-in-out ${
                visible ? 'translate-y-0' : '-translate-y-full'
            }`}
        >
            <div className="flex justify-between items-center max-w-7xl mx-auto px-4 py-4">
                <div className="text-2xl font-bold tracking-tighter font-display transform hover:-rotate-1">
                    <Link to="/" onClick={handleNavClick('/')}>MICHAL CHAMRÁD</Link>
                </div>
                
                {/* Hamburger Menu Button - visible only on mobile */}
                <button 
                    className="md:hidden brutalist-button p-2"
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                >
                    <div className={`w-6 h-0.5 bg-current mb-1 transition-transform ${isMenuOpen ? 'rotate-45 translate-y-1.5' : ''}`}></div>
                    <div className={`w-6 h-0.5 bg-current mb-1 ${isMenuOpen ? 'opacity-0' : ''}`}></div>
                    <div className={`w-6 h-0.5 bg-current ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : ''}`}></div>
                </button>

                {/* Desktop Navigation */}
                <div className="hidden md:flex gap-6">
                    <Link to="/about" onClick={handleNavClick('/about', 'about')} className="brutalist-button transform hover:rotate-1">ABOUT</Link>
                    <Link to="/projects" onClick={handleNavClick('/projects', 'projects')} className="brutalist-button transform hover:rotate-1">PROJECTS</Link>
                    <Link to="/contact" onClick={handleNavClick('/contact', 'contact')} className="brutalist-button transform hover:rotate-1">CONNECT</Link>
                </div>
            </div>

            {/* Mobile Navigation Menu */}
            <div className={`md:hidden brutalist-container m-0 ${isMenuOpen ? 'block' : 'hidden'}`}>
                <div className="flex flex-col gap-4">
                    <Link to="/about" className="brutalist-button w-full text-center" onClick={handleNavClick('/about', 'about')}>ABOUT</Link>
                    <Link to="/projects" className="brutalist-button w-full text-center" onClick={handleNavClick('/projects', 'projects')}>PROJECTS</Link>
                    <Link to="/contact" className="brutalist-button w-full text-center" onClick={handleNavClick('/contact', 'contact')}>CONNECT</Link>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
